'use strict';

const GtListDirective = [function() {
  return {
    restrict: 'A',
    templateUrl: 'app/shared/list/list.html',
    link(scope) {
      //default sortOrder
      if(!scope.order) { scope.order = scope.listObject.meta[0].value; }
      //default search: all fields
      if(!scope.listObject.search) { scope.listObject.search = '$'; }

      if(!scope.pageSizes) { scope.pageSizes = ['10', '20', '50', '100']; }
      if(!scope.pageSize) { scope.pageSize = scope.pageSizes[0]; }
      if(!scope.currentPage) { scope.currentPage = 1; }

      scope.sortClick = function(value) {
        if(scope.order === value) {
          scope.order = '-' + value;
        } else {
          scope.order = value;
        }
      };
    }
  };
}];
export default GtListDirective;
